module.exports = __webpack_public_path__ + "media/images/ceremony/top/plan/plan1-c74ae5539a97ff5ff64426625d349b13.jpg";